import { render, staticRenderFns } from "./MenuHeader.vue?vue&type=template&id=2150f08b&"
import script from "./MenuHeader.vue?vue&type=script&lang=js&"
export * from "./MenuHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports